import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackMetaAccountConnectionInitiated.meta';

export const useTrackMetaAccountConnectionInitiated = () => {
  const { track } = useAnalyticsUtilities();

  const trackMetaAccountConnectionInitiated = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackMetaAccountConnectionInitiated };
};
